import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import Logo from "../../../assets/Images/logo.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllExpenseSummaryReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearExpenseSummaryReportList } from "../reportsSlice";
import { formatIndianNumber } from "../../../_helper/helper";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { sumBy } from "lodash";

const ExpenseSummaryReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("expensesummaryreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `

      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
          
        }
             .registerreport-print thead tr th {
          padding:2px 1px ;
          line-height:12px
          }
          .registerreport-print tbody tr td {
          font-size:10px}
       @page landscapePage {
       size: landscape;}
        .salesmanwisereport-print-break{
          page: landscapePage;
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const ExpenseSummaryReportList = useAppSelector(
    (state) => state.reports.ExpenseSummaryReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      sr_id: state?.sr_id,
      from_date: state?.from_date,
      to_date: state?.to_date,
    };
    const res = await dispatch(getAllExpenseSummaryReport(payload));
    if (res.meta.requestStatus === "fulfilled") {
      setPrintStyles();
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("expensesummaryreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearExpenseSummaryReportList());
    };
  }, []);

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {ExpenseSummaryReportList && ExpenseSummaryReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 20,
                        top: 20,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "10px", marginBottom: "10px" }}
                    >
                      <tr>
                        <td
                          rowSpan={3}
                          style={{
                            width: "200px",
                            border: "1px solid lightgray",
                          }}
                        >
                          <div style={{ height: "100px" }}>
                            <img
                              src={`${Logo}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          HARIHAR FOODS PVT LTD.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>Expense Summary Report </h6>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid lightgray",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            For Period :{" "}
                            {state.from_date &&
                              state.to_date &&
                              `( ${moment(state.from_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} )`}
                          </p>
                        </td>
                      </tr>
                    </table>

                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print mb-5`}
                    >
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Name
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {ExpenseSummaryReportList[0]?.sr_name?.toUpperCase()}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Date
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {state.from_date &&
                            state.to_date &&
                            `${moment(state.from_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} to ${moment(state.to_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} `}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Amount Of Bill
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {formatIndianNumber(
                            ExpenseSummaryReportList[0]?.net_amount
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "lightgray",
                            fontWeight: "bold",
                            border: "1px solid gray",
                          }}
                        >
                          Net Amount Settled
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          {formatIndianNumber(
                            ExpenseSummaryReportList[0]?.total_amount
                          )}
                        </td>
                      </tr>
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print salesmanwisereport-print-break`}
                      // style={{
                      //   width: "fit-content",
                      // }}
                    >
                      <thead>
                        <tr>
                          <td
                            style={{
                              textAlign: "center",
                              backgroundColor: "lightgray",
                            }}
                          >
                            {" "}
                            <strong>Name</strong>{" "}
                          </td>
                          <td
                            colSpan={
                              formRenderProps.valueGetter("filter_columns")
                                .length - 1
                            }
                          >
                            <strong>
                              {ExpenseSummaryReportList[0]?.sr_name?.toUpperCase()}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              textAlign: "center",
                              backgroundColor: "lightgray",
                            }}
                          >
                            <strong>Date</strong>
                          </td>
                          <td
                            colSpan={
                              formRenderProps.valueGetter("filter_columns")
                                .length - 1
                            }
                          >
                            <strong>
                              {state.from_date &&
                                state.to_date &&
                                `${moment(state.from_date, "YYYY-MM-DD").format(
                                  "DD/MM/YYYY"
                                )} to ${moment(
                                  state.to_date,
                                  "YYYY-MM-DD"
                                ).format("DD/MM/YYYY")} `}
                            </strong>
                          </td>
                        </tr>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          {checkInclude("expense_date", formRenderProps) && (
                            <th style={{ minWidth: 100 }}>Date</th>
                          )}
                          {checkInclude("status", formRenderProps) && (
                            <th style={{ minWidth: 60 }}>Status</th>
                          )}
                          {checkInclude("from_city_name", formRenderProps) && (
                            <th>From City</th>
                          )}
                          {checkInclude("to_city_name", formRenderProps) && (
                            <th>To City</th>
                          )}
                          {checkInclude("kms_travelled", formRenderProps) && (
                            <th style={{ minWidth: 50 }}>Km.</th>
                          )}
                          {checkInclude(
                            "mode_of_transport_name",
                            formRenderProps
                          ) && <th>Mode Of Transport</th>}
                          {checkInclude(
                            "Working_agent_town_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 120 }}>
                              Working Agent / Distributor
                            </th>
                          )}
                          {checkInclude(
                            "city_town_visited_name",
                            formRenderProps
                          ) && (
                            <th style={{ minWidth: 100 }}>City/Twon Visited</th>
                          )}
                          {checkInclude(
                            "fare_for_transport",
                            formRenderProps
                          ) && <th>Fare For Transport</th>}
                          {checkInclude(
                            "fare_transport_allowance_value",
                            formRenderProps
                          ) && <th>Fare Trans. Allow.</th>}
                          {checkInclude(
                            "courier_post_expense_value",
                            formRenderProps
                          ) && <th>Co. / Post Exp.</th>}
                          {checkInclude(
                            "stationary_xerox_expense_value",
                            formRenderProps
                          ) && <th>St. / Xerox Exp.</th>}
                          {checkInclude(
                            "daily_allowances_hq_value",
                            formRenderProps
                          ) && <th>Daily Allow. Hq (DA)</th>}
                          {checkInclude(
                            "night_halt_value",
                            formRenderProps
                          ) && <th>N. Halt</th>}
                          {checkInclude(
                            "petro_expense_per_km_value",
                            formRenderProps
                          ) && <th>Pet. Exp. Per KM</th>}
                          {checkInclude(
                            "other_expense_value",
                            formRenderProps
                          ) && <th>O. Exp. (Misc. Exp.)</th>}
                          {checkInclude(
                            "da_up_country_more_than_50_km_value",
                            formRenderProps
                          ) && <th>Da Up Coun. More Than 50 KM</th>}
                          {checkInclude(
                            "night_journey_value",
                            formRenderProps
                          ) && <th>N. Jour.</th>}
                          {checkInclude("net_amount", formRenderProps) && (
                            <th>Tot. Amount</th>
                          )}
                          {checkInclude(
                            "disallowed_amount",
                            formRenderProps
                          ) && <th>Tot. Dis. Allow. Amount</th>}
                          {checkInclude(
                            "additional_expense_amount",
                            formRenderProps
                          ) && <th>Add. Exp. Amount</th>}
                          {checkInclude("total_expense", formRenderProps) && (
                            <th>Tot. Exp.</th>
                          )}
                          {checkInclude("sales_amount", formRenderProps) && (
                            <th>Sales Amount</th>
                          )}
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {ExpenseSummaryReportList[0].expense_summary_value_details.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                {checkInclude(
                                  "expense_date",
                                  formRenderProps
                                ) && (
                                  <td style={{ wordBreak: "break-word" }}>
                                    {moment(
                                      item?.expense_date,
                                      "DD/MM/YYYY"
                                    ).format("DD-MMM-YYYY")}
                                  </td>
                                )}
                                {checkInclude("status", formRenderProps) && (
                                  <td>
                                    {item?.status ? "Verified" : "Pending"}
                                  </td>
                                )}
                                {checkInclude(
                                  "from_city_name",
                                  formRenderProps
                                ) && <td>{item?.from_city_name}</td>}

                                {checkInclude(
                                  "to_city_name",
                                  formRenderProps
                                ) && <td>{item?.to_city_name}</td>}
                                {checkInclude(
                                  "kms_travelled",
                                  formRenderProps
                                ) && <td>{item?.kms_travelled}</td>}
                                {checkInclude(
                                  "mode_of_transport_name",
                                  formRenderProps
                                ) && <td>{item?.mode_of_transport_name}</td>}
                                {checkInclude(
                                  "Working_agent_town_name",
                                  formRenderProps
                                ) && <td>{item?.Working_agent_town_name}</td>}
                                {checkInclude(
                                  "city_town_visited_name",
                                  formRenderProps
                                ) && <td>{item?.city_town_visited_name}</td>}
                                {checkInclude(
                                  "fare_for_transport",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.fare_for_transport || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "fare_transport_allowance_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.fare_transport_allowance_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "courier_post_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.courier_post_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "stationary_xerox_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.stationary_xerox_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "daily_allowances_hq_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.daily_allowances_hq_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "night_halt_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.night_halt_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "petro_expense_per_km_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.petro_expense_per_km_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "other_expense_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.other_expense_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "da_up_country_more_than_50_km_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.da_up_country_more_than_50_km_value ||
                                        0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "night_journey_value",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.night_journey_value || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "net_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.net_amount || 0)}
                                  </td>
                                )}

                                {checkInclude(
                                  "disallowed_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.disallowed_amount || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "additional_expense_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.additional_expense_amount || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "total_expense",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.total_expense || 0
                                    )}
                                  </td>
                                )}
                                {checkInclude(
                                  "sales_amount",
                                  formRenderProps
                                ) && (
                                  <td className="text-end">
                                    {formatIndianNumber(
                                      item?.sales_amount || 0
                                    )}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )}
                        {/* Total Row */}
                        <tr style={{ fontWeight: "bold" }}>
                          {checkInclude("expense_date", formRenderProps) && (
                            <td>Total</td>
                          )}
                          {checkInclude("status", formRenderProps) && <td></td>}
                          {checkInclude("from_city_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("to_city_name", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude("kms_travelled", formRenderProps) && (
                            <td></td>
                          )}
                          {checkInclude(
                            "mode_of_transport_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "Working_agent_town_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "city_town_visited_name",
                            formRenderProps
                          ) && <td></td>}
                          {checkInclude(
                            "fare_for_transport",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "fare_for_transport"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "fare_transport_allowance_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "fare_transport_allowance_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "courier_post_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "courier_post_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "stationary_xerox_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "stationary_xerox_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "daily_allowances_hq_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "daily_allowances_hq_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "night_halt_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "night_halt_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "petro_expense_per_km_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "petro_expense_per_km_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "other_expense_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "other_expense_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "da_up_country_more_than_50_km_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "da_up_country_more_than_50_km_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "night_journey_value",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "night_journey_value"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("net_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "net_amount"
                                )
                              )}
                            </td>
                          )}

                          {checkInclude(
                            "disallowed_amount",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "disallowed_amount"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude(
                            "additional_expense_amount",
                            formRenderProps
                          ) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "additional_expense_amount"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("total_expense", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "total_expense"
                                )
                              )}
                            </td>
                          )}
                          {checkInclude("sales_amount", formRenderProps) && (
                            <td className="text-end">
                              {formatIndianNumber(
                                sumBy(
                                  ExpenseSummaryReportList[0]
                                    .expense_summary_value_details,
                                  "sales_amount"
                                )
                              )}
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default ExpenseSummaryReport;
